// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"a47157e7","990":"3512e648"}[chunkId] + ".chunk.css";
};